import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from "../../../../../dataGrid";
import GridConfig from "./gridConfig";
import GridHeader from "../../../components/GridHeader";
import StatusBar from "../../../../../dataGrid/StatusBar";
import { getSpecialNeeds } from "../../../../utils";
import { isEqual } from "lodash";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../../appConfigContext";
import styles from "../../../common/GridStyles";
class DueBillsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.gridConfig = new GridConfig({
      columnConfig: this.props.configJSON?.gridColumnConfig,
    });
    this.gridContext = {
      specialNeedsOptions: getSpecialNeeds(this.props.serviceLevelList),
    };
  }

  componentDidMount() {
    this.props.glEventHub.on("dueBillsGrid", this.onSearchTextChanged);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.serviceLevelList, this.props.serviceLevelList)) {
      this.gridContext = {
        specialNeedsOptions: getSpecialNeeds(this.props.serviceLevelList),
      };
    }
  }

  componentWillUnmount() {
    this.props.glEventHub.off("dueBillsGrid", this.onSearchTextChanged);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.onGridReady({ api });
    this.selectPros();
  };

  selectPros = () => {
    this.gridApi.forEachNode((node) => {
      if (
        this.props.selectedPros.includes(node.data.proId) ||
        node.data.isInPlan
      ) {
        node.setSelected(true);
      }
    });
  };

  isRowSelectable = (params) => {
    return !params.data.isInPlan;
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Due Bills",
        filterCondition: "",
      },
    ];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, rowData } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="Due Bills"
          headerId="dueBillsGrid"
          glEventHub={this.props.glEventHub}
        />
        <DataGrid
          rowData={rowData}
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          suppressRowClickSelection
          quickFilterText={this.state.searchText}
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          context={this.gridContext}
          rowClassRules={config.rowClassRules}
          onGridReady={this.onGridReady}
          getRowNodeId={(data) => data.proId}
          isRowSelectable={this.isRowSelectable}
        />
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(DueBillsGrid);
